import { useMutation } from 'react-query';

import { archiveProject } from 'shared/api/projects/http';

const useMutateArchiveProject = (options = undefined) => useMutation((id) => archiveProject(id), options);

export default useMutateArchiveProject;
